import StripeAddCardForm from './StripeAddCardForm';

export default StripeAddCardForm;
